<template>
    <div style="height: 100%">
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="状态" prop="status">
                        <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable
                            clearable>
                            <el-option label="增加" value="true"></el-option>
                            <el-option label="修改" value="false"></el-option>
                            <el-option label="删除" value="false"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <!-- <div class="u-btn" @click="deleteF('0')">批量删除</div> -->
                    <el-button type="primary" icon="el-icon-delete" @click="deleteF" size="small">批量删除</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="adminList" pagination
                    :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[5, 10, 20, 30, 50]" :current-page.sync="page.currentPage" :page-size="page.pageSize"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog :title="title" :visible.sync="isEdit" top="30vh" width="487px" :append-to-body="true">
            <template>
                <el-form :model="newForm" label-width="74px" size="small" style="width: 100%">
                    <el-form-item label="账号名称">
                        <el-input class="borderNone" v-model="newForm.name" placeholder="请输入账号" :minlength="6"
                            :maxlength="20" @input="getName" style="width: 100%">
                            <div slot="prefix" style="color: #303033; margin-right: 10px; margin-left: 10px">
                                {{ platformId }}@
                            </div>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input placeholder="请输入密码" v-model="newForm.password" :minlength="8" :maxlength="20"
                            onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="再次确认">
                        <el-input :minlength="8" :maxlength="20" v-model="newForm.confirmPassword" placeholder="请再次输入密码"
                            onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"></el-input>
                    </el-form-item>
                    <el-form-item label="角色">
                        <el-select placeholder="请选择角色" v-model="newForm.roleId" style="width: 100%">
                            <el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isEdit = false">取消</div>
                    <div class="info-s" @click="addAdmin">确定</div>
                    <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
            <el-button type="primary" @click="isUp = false">确定</el-button> -->
                </div>
            </template>
        </el-dialog>
        <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isD = false">取消</div>
                    <div class="info-s" @click="isD = false">确定</div>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
    },
    data() {
        return {
            isD: false,
            title: '添加账号',
            isEdit: false,
            name: '',
            dataList: {
                list: [
                    { title: '系统管理', path: '', type: '0' },
                    { title: '操作记录', path: '', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '操作记录', path: '', type: '0' },
                    { title: '数据筛选', path: '', type: '1' }
                ]
            },
            newForm: {
                name: '',
                password: '',
                confirmPassword: '',
                roleId: null
            },
            searchForm: {
                username: '', // 	否 	string 	账号名称名称
                time: ''
            },
            value1: [],
            brandList: [],
            columns: [
                { type: 'selection', minWidth: '80', fixed: 'left' },
                { label: 'ID', prop: 'roleName', minWidth: '120' },
                { label: '管理员', type: 'index', width: '120' },
                { label: '业务类型', prop: 'username', minWidth: '220' },
                { label: '操作模块', prop: 'roleName', minWidth: '100' },
                { label: '操作时间', prop: 'createdTime', minWidth: '100' },
                {
                    label: '操作',
                    minWidth: '120',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>

                                <span style='color:#2D46EE;cursor:pointer;' onClick={() => { this.deleteF(scope.row.id) }}>删除</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            adminList: [],
            roleList: [],
            platformId: "",
            rowId: null
        }
    },

    created() {
        this.getAdminList()
        this.getRoleList()
        let userInfo = sessionStorage.getItem('userInfo')
        this.platformId = JSON.parse(userInfo).platformId;
    },
    methods: {
        addAdmin() {
            if (this.newForm.name == '') {
                return this.$message.warning('请输入账号名称')
            }
            if (this.newForm.password == '') {
                return this.$message.warning('请输入密码')
            }
            if (this.newForm.confirmPassword == '') {
                return this.$message.warning('请输入确认密码')
            }
            if (this.newForm.roleId == '' || this.newForm.roleId == null) {
                return this.$message.warning('请选择角色')
            }
            if (this.newForm.confirmPassword !== this.newForm.password) {
                return this.$message.warning('确认密码与密码不一致')
            }
            this.newForm.name = this.newForm.name;
            let data = this.newForm;
            if (this.title == '添加账号') {
                this.axios.put('/admin/add', data)
                    .then(res => {
                        if (res.code == 0) {
                            this.newForm.name = '';
                            this.newForm.password = '';
                            this.newForm.confirmPassword = '';
                            this.newForm.roleId = null;
                            this.isEdit = false;
                            this.$message.success('添加成功')
                            this.fetchData('reset')
                        }
                    })
            } else {
                data.id = this.rowId;
                // delete data.confirmPassword
                this.axios.post('/admin/update', data)
                    .then(res => {
                        if (res.code == 0) {
                            this.newForm.name = '';
                            this.newForm.password = '';
                            this.newForm.confirmPassword = '';
                            this.newForm.roleId = null;
                            this.isEdit = false;
                            this.$message.success('编辑成功')
                            this.fetchData('reset')
                        }
                    })
            }
        },
        getName(e) {
            console.log(e)
            this.newForm.name = e.replace(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/g, "")
        },
        fetchData(type) {
            this.page.pageNo = 1
            if (type == 'search') {

            } else {
                this.searchForm.username = '';
                this.value1 = []
            }
            this.getAdminList()
        },
        getAdminList() {
            let data = {
                username: this.searchForm.username,
                createdTimeStart: this.value1[0] || '',
                createdTimeEnd: this.value1[1] || '',
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize
            }
            this.axios.post('/admin/getPageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.adminList = res.data.list;
                        this.page.totalNum = res.data.totalNum;
                    }
                })
        },
        handleCurrentChange(e) {
            console.log(e)
            this.page.pageNo = e
            this.getAdminList()
        },
        handleSizeChange(e) {
            this.page.pageSize = e
            this.getAdminList()
        },
        getRoleList() {
            this.axios.get('/role/list')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.roleList = res.data.list;
                    }

                })
        },
        add() {
            this.isEdit = true
            this.title = '添加账号'
            this.newForm.name = '';
            this.newForm.password = '';
            this.newForm.confirmPassword = '';
            this.newForm.roleId = null;
            this.getRoleList()
        },
        edit(e) {
            console.log(e)
            this.getRoleList()
            this.rowId = e.row.id;
            this.isEdit = true
            this.title = '编辑账号';
            this.axios.get('/admin/queryUser?id=' + e.row.id)
                .then(res => {
                    console.log(res)
                    this.newForm.roleId = res.data.roleId;
                    this.newForm.confirmPassword = res.data.password;
                    this.newForm.password = res.data.password;
                    let name = res.data.username.replace(this.platformId + '@', '')
                    this.newForm.name = name;

                })

        },
        deleteF(id) {
            this.isD = true
            // this.$confirm('是否确认删除？删除后不可恢复数据！', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.axios.delete('/admin/delete/' + id)
            //         .then(res => {
            //             console.log(res)
            //             if (res.code == 0) {
            //                 this.page.pageNo = 1;
            //                 this.getAdminList()
            //                 this.$message({
            //                     type: 'success',
            //                     message: '删除成功!'
            //                 });
            //             }
            //         })

            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消删除'
            //     });
            // });
        }
    }
}
</script>
  
<style scoped lang="scss">
.u-btn {
    width: 92px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #2D46EE;
    opacity: 1;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    color: #2D46EE;
    text-align: center;
    cursor: pointer;
    margin-right: 18px;
}

::v-deep .el-input--prefix .el-input__inner {
    padding-left: 30%;
}

::v-deep .el-dialog__wrapper {
    text-align: center;
    white-space: nowrap;
    overflow: auto;

    &:after {
        content: "";
        display: inline-block;
        vertical-align: middle;
        height: 100%;
    }

    .el-dialog {
        margin: 30px auto !important;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        white-space: normal;
    }
}

::v-deep .el-dialog__header {
    text-align: left;
    border-bottom: none;
}

.info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 0px;
    color: #303033;
    opacity: 1;
    text-align: left;
}

.info-b {
    margin-left: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 40px;
    color: #303033;
    text-align: left;
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

.title {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 78px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 78px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }
}

/deep/ .el-table {
    color: #303033;
}
</style>
  
  